import {createRef, useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON, PostUploadJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {useNavigate, useParams} from "react-router-dom";
import {BreadCrumbs} from "../../../components/open/pages";
import {
    ThinAddIcon,
    ThinCameraIcon,
    ThinCardIcon,
    ThinCaretDownIcon,
    ThinContractIcon,
    ThinCreditScoreIcon,
    ThinEditIcon,
    ThinInfoIcon,
    ThinInsuranceIcon,
    ThinJobIcon,
    ThinMonitoringIcon,
    ThinPersonCalendarIcon,
    ThinPrintIcon,
    ThinTimeIcon,
    ThinTrashIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian, PersianToGregorian} from "../../../components/techaran/date-convert";
import {AdminsAddEditStaffModal} from "./add-edit-staff";
import {GradeToString} from "../students/list";
import {AdminsStaffInsuranceEditModal} from "./edit-insurance";
import {AdminsStaffAddEditSalarySourceModal} from "./add-edit-salary-source";
import {RemoveModal} from "../../../components/template/remove-modal";
import {AdminsStaffEditContractModal} from "./edit-contract";
import {AdminsStaffSetJobModal} from "./set-job-modal";
import {AdminsStaffAssignCardModal} from "./assign-card";
import {Calendar, DayRange} from "@hassanmojab/react-modern-calendar-datepicker";
import ClickOutsideDetector from "../../../components/clickOutside/click-outside";
import {staffAttendCreatedByToString} from "./attend";

interface salarySourcesInterface {
    id: number,
    title: string,
    price: number,
    createdAt: string,
}

interface salaryPaidOfEachPersonInterface {
    id: number,
    title: string,
    price: number,
    createdAt: string,
}

interface attendListInterface {
    id: number,
    createdAt: string,
    isExit: boolean,
    createdBy: number,
}

export const AdminsStaffDetailsScreen = () => {
    const {staffId} = useParams();
    const [data, setData] = useState({
        loaded: false,
        firstname: '',
        lastname: '',
        tell: '',
        hasPartner: false,
        homeTell: '',
        partnerTell: '',
        partnerFullname: '',
        partnerJob: '',
        teachingGrade: 0,
        isFemale: false,
        birthDate: '2000-01-01',
        certificate: '',
        major: '',
        yearsActive: 0,
        mustHoursPerWeek: 0,
        bankAccountNumber: '',
        hasInsurance: false,
        insuranceDaysPerMonth: 0,
        insuranceCost: 0,
        salary: 0,
        img: '',
        nationalCode: '',
        fatherName: '',
        birthCity: '',
        address: '',
        contractStartTime: '2000-01-01',
        contractExpiresAt: '2000-01-01',
        maxWorkingHoursPerDay: 0,
        cardCode: '',
        isInside: false,
        isProfileComplete: false,
        jobTitle: '',
        isTeacher: false,
        childCount: 0,
        totalFromSources: 0,
        sources: [] as salarySourcesInterface[],
    });
    const [salariesPaid, setSalariesPaid] = useState<salaryPaidOfEachPersonInterface[]>([]);
    const navigate = useNavigate();
    const [entranceList, setEntranceList] = useState<attendListInterface[]>([]);
    const [time, setTime] = useState<DayRange>({from: null, to: null});
    const [filters, setFilters] = useState({
        shown: '' as '' | 'filters' | 'time'
    });
    const fetchAttend = () => {
        setFilters({shown: ''});
        const t = {...time};
        let fromString = '';
        let toString = '';
        if (t.from !== null && t.to !== null && typeof t.from !== 'undefined' && typeof t.to !== 'undefined') {
            const g = PersianToGregorian(`${t.from.year}-${t.from.month}-${t.from.day}`);
            const g2 = PersianToGregorian(`${t.to.year}-${t.to.month}-${t.to.day}`);
            fromString = g;
            toString = g2;
        } else {
            const today = new Date();
            const priorDate = new Date(new Date().setDate(today.getDate() - 30));
            const todayIso = today.toISOString().split('T')[0].split('-');
            const priorIso = priorDate.toISOString().split('T')[0].split('-');
            let from = {
                year: parseInt(priorIso[0]),
                month: parseInt(priorIso[1]),
                day: parseInt(priorIso[2]),
            };
            let to = {
                year: parseInt(todayIso[0]),
                month: parseInt(todayIso[1]),
                day: parseInt(todayIso[2]),
            };
            const g1 = GregorianToPersian(priorDate).split('-');
            from = {
                year: parseInt(g1[0]),
                month: parseInt(g1[1]),
                day: parseInt(g1[2]),
            };
            const g2 = GregorianToPersian(today).split('-');
            to = {
                year: parseInt(g2[0]),
                month: parseInt(g2[1]),
                day: parseInt(g2[2]),
            };
            const fromMonth = from.month < 10 ? `0${from.month}` : from.month;
            const fromDay = from.day < 10 ? `0${from.day}` : from.day;
            let g = `${from.year}-${fromMonth}-${fromDay}`;
            const toMonth = to.month < 10 ? `0${to.month}` : to.month;
            const toDay = to.day < 10 ? `0${to.day}` : to.day;
            fromString = PersianToGregorian(`${from.year}-${from.month}-${from.day}`);
            toString = PersianToGregorian(`${to.year}-${to.month}-${to.day}`);
            setTime({
                from: from,
                to: to,
            });
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/details/entrances',
            {
                id: staffId,
                from: fromString,
                to: toString,
            },
            true,
            (d: {
                result: string,
                reason: string,
                list: attendListInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setEntranceList(d.list === null ? [] : d.list);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/staff/details',
            {
                id: staffId as string,
            },
            true,
            (d: {
                result: string,
                reason: string,
                firstname: string,
                lastname: string,
                tell: string,
                hasPartner: 0 | 1,
                homeTell: string,
                partnerTell: string,
                partnerFullname: string,
                partnerJob: string,
                teachingGrade: number,
                isFemale: 0 | 1,
                birthDate: string,
                certificate: string,
                major: string,
                yearsActive: number,
                mustHoursPerWeek: number,
                bankAccountNumber: string,
                hasInsurance: 0 | 1,
                insuranceDaysPerMonth: number,
                insuranceCost: number,
                salary: number,
                img: string,
                nationalCode: string,
                fatherName: string,
                birthCity: string,
                address: string,
                contractStartTime: string,
                contractExpiresAt: string,
                maxWorkingHoursPerDay: number,
                cardCode: string,
                isInside: 0 | 1,
                isProfileComplete: 0 | 1,
                jobTitle: string,
                isTeacher: 0 | 1,
                childCount: number,
                totalFromSources: number,
                sources: salarySourcesInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login') {
                        AuthRedirectAdmins();
                    } else if (d.reason === 'access') {
                        navigate('/admins', {replace: true});
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                    } else if (d.reason === 'not-found') {
                        navigate('/admins/staff', {replace: true});
                        ShowSnackbar(
                            'کارمند یافت نشد.',
                            'باشه',
                            5000,
                        );
                    }
                    return;
                }
                setData({
                    address: d.address,
                    bankAccountNumber: d.bankAccountNumber,
                    birthCity: d.birthCity,
                    cardCode: d.cardCode,
                    birthDate: d.birthDate,
                    certificate: d.certificate,
                    childCount: d.childCount,
                    contractExpiresAt: d.contractExpiresAt,
                    contractStartTime: d.contractStartTime,
                    firstname: d.firstname,
                    fatherName: d.fatherName,
                    hasInsurance: d.hasInsurance === 1,
                    hasPartner: d.hasPartner === 1,
                    homeTell: d.homeTell,
                    salary: d.salary,
                    sources: d.sources === null ? [] : d.sources,
                    isTeacher: d.isTeacher === 1,
                    jobTitle: d.jobTitle,
                    lastname: d.lastname,
                    insuranceCost: d.insuranceCost,
                    insuranceDaysPerMonth: d.insuranceDaysPerMonth,
                    isFemale: d.isFemale === 1,
                    img: d.img,
                    isProfileComplete: d.isProfileComplete === 1,
                    major: d.major,
                    maxWorkingHoursPerDay: d.maxWorkingHoursPerDay,
                    mustHoursPerWeek: d.mustHoursPerWeek,
                    nationalCode: d.nationalCode,
                    partnerFullname: d.partnerFullname,
                    tell: d.tell,
                    partnerJob: d.partnerJob,
                    isInside: d.isInside === 1,
                    partnerTell: d.partnerTell,
                    teachingGrade: d.teachingGrade,
                    totalFromSources: d.totalFromSources,
                    yearsActive: d.yearsActive,
                    loaded: true,
                });
                document.title = d.firstname + " " + d.lastname + ' | منابع انسانی | اتوماسیون';
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const imgRef = createRef<any>();
    const onPhotoSelected = () => {
        const c = imgRef.current as HTMLInputElement;
        const x = c.files;
        if (x === null || x!.length !== 1) {
            c.value = '';
            return;
        }
        const fileSize = x[0].size / 1048576;
        const ext = x[0].name.split('.')[x[0].name.split.length - 1].toLowerCase();
        if (fileSize > 10) {
            c.value = '';
            ShowSnackbar(
                'اندازه حجم تصویر باید کمتر از ۱۰ مگابایت باشد.',
                'باشه',
                5000,
            );
            return;
        }
        if (ext !== 'jpg' && ext !== 'png' && ext !== 'jpeg') {
            c.value = '';
            ShowSnackbar(
                'پسوند فایل تصویر باید JPG یا PNG باشد.',
                'باشه',
                5000,
            );
            return;
        }
        ShowProgressLoading();
        PostUploadJSON(
            Apis.server + '/core/admins/staff/details/change-img',
            {
                id: staffId as string,
                img: x![0],
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                photo: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    'تصویر جدید برای کارمند ذخیره شد.',
                    'باشه',
                    5000,
                );
                fetchData();
                window.scrollTo({top: 0, behavior: 'smooth'});
            },
            () => {
                HideProgressLoading();
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const openPhotoPicker = () => {
        (imgRef.current as HTMLInputElement).click();
    };
    const [tab, setTab] = useState('info' as 'info' | 'salaries' | 'paid' | 'insurance' | 'contract' | 'attend');
    const [editModal, setEditModal] = useState(false);
    const [insuranceModal, setInsuranceModal] = useState(false);
    const [addEditSource, setAddEditSource] = useState({
        show: false,
        edit: false,
        id: 0,
        title: '',
        price: 0,
    });
    const [removeSourceModal, setRemoveSourceModal] = useState({
        show: false,
        id: 0,
        title: '',
    });
    const [contractModal, setContractModal] = useState(false);
    const [selectJobModal, setSelectJobModal] = useState(false);
    const fetchSalariesPaid = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/details/paid',
            {
                id: staffId as string,
            },
            true,
            (d: {
                result: string,
                reason: string,
                list: salaryPaidOfEachPersonInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setSalariesPaid(d.list === null ? [] : d.list);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const t = tab;
        if (t === 'paid') {
            fetchSalariesPaid();
        } else if(t === 'attend'){
            fetchAttend();
        }
    }, [tab]);
    const [rfidModal, setrfidModal] = useState(false);
    const [removeCard, setRemoveCard] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {url: '/admins', title: 'اتوماسیون'},
                {url: '/admins/staff', title: 'منابع انسانی'},
                {
                    url: `/admins/staff/view/${staffId}`,
                    title: data.loaded ? `${data.firstname} ${data.lastname}` : '...'
                },
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="d-none d-lg-block" style={{height: 60}}/>
                                <div className="student-profile">
                                    <i style={{
                                        backgroundImage: `url(${ServerImage(data.img, 500, 0)})`,
                                        // width: '100%',
                                        // borderRadius: 10
                                    }}>
                                        <button className={"student-profile-picker open-tooltip"}
                                                style={{top: 10, left: 10}}
                                                onClick={openPhotoPicker}>
                                            <ThinCameraIcon/>
                                            <i>تصویر جدید</i>
                                        </button>
                                    </i>
                                    <b>{data.firstname + " " + data.lastname}</b>
                                    <span style={{cursor: 'pointer'}}
                                          onClick={() => setSelectJobModal(true)}>{data.jobTitle === '' ? 'بدون شغل' : data.jobTitle}</span>
                                    <em data-color={data.isInside ? 'blue' : 'red'}>
                                        {data.isInside ? 'حاضر' : 'غایب'}
                                    </em>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="open-tabbar" style={{marginTop: 20}}>
                                    <div className="open-tabbar-inner">
                                        <button onClick={() => {
                                            setTab('info');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'info' ? 'active' : ''}>
                                            <ThinInfoIcon/>
                                            مشخصات
                                        </button>
                                        <button onClick={() => {
                                            setTab('contract');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'contract' ? 'active' : ''}>
                                            <ThinContractIcon/>
                                            قرارداد
                                        </button>
                                        <button onClick={() => {
                                            setTab('insurance');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'insurance' ? 'active' : ''}>
                                            <ThinInsuranceIcon/>
                                            بیمه
                                        </button>
                                        <button onClick={() => {
                                            setTab('salaries');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'salaries' ? 'active' : ''}>
                                            <ThinMonitoringIcon/>
                                            حقوق
                                        </button>
                                        <button onClick={() => {
                                            setTab('paid');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'paid' ? 'active' : ''}>
                                            <ThinCreditScoreIcon/>
                                            دریافتی‌ها
                                        </button>
                                        <button onClick={() => {
                                            setTab('attend');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'attend' ? 'active' : ''}>
                                            <ThinPersonCalendarIcon/>
                                            حضورغیاب
                                        </button>
                                    </div>
                                </div>
                                {
                                    tab === 'info' ?
                                        <>
                                            <div className="screen-card">
                                                <div className="screen-card-header">
                                                    <b>مشخصات کارمند</b>
                                                    <div className="d-flex align-items-center" style={{gap: 10}}>
                                                        <button onClick={() => setSelectJobModal(true)}>
                                                            <ThinJobIcon/>
                                                            <span>تعیین شغل</span>
                                                        </button>
                                                        <button onClick={() => setEditModal(true)}>
                                                            <ThinEditIcon/>
                                                            <span>ویرایش</span>
                                                        </button>
                                                        <button onClick={openPhotoPicker}>
                                                            <ThinCameraIcon/>
                                                            <span>آپلود تصویر</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="student-info">
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <span>نام و نام خانوادگی:</span>
                                                            <b>{data.firstname + " " + data.lastname}</b>
                                                            <span>تلفن همراه:</span>
                                                            <b>{StringDigitsConvertToPersian(data.tell.replaceAll('+98', '0'))}</b>
                                                            <span>وضعیت تاهل:</span>
                                                            <b>{data.hasPartner ? 'متاهل' : 'مجرد'}</b>
                                                            <span>تلفن منزل:</span>
                                                            <b>{StringDigitsConvertToPersian(data.homeTell.replaceAll('+98', '0'))}</b>
                                                            {
                                                                data.hasPartner ?
                                                                    <>
                                                                        <span>تلفن همسر:</span>
                                                                        <b>{StringDigitsConvertToPersian(data.partnerTell.replaceAll('+98', '0'))}</b>
                                                                        <span>نام همسر:</span>
                                                                        <b>{data.partnerFullname}</b>
                                                                        <span>شغل همسر:</span>
                                                                        <b>{data.partnerJob}</b>
                                                                    </> : null
                                                            }
                                                            <span>پایه آموزشی:</span>
                                                            <b>{GradeToString(data.teachingGrade)}</b>
                                                            <span>جنسیت:</span>
                                                            <b>{data.isFemale ? 'زن' : 'مرد'}</b>
                                                            <span>تاریخ تولد:</span>
                                                            <b>{StringDigitsConvertToPersian(GregorianToPersian(data.birthDate).replaceAll('-', '/'))}</b>
                                                            <span>مدرک تحصیلی:</span>
                                                            <b>{data.certificate}</b>
                                                            <span>رشته تحصیلی:</span>
                                                            <b>{data.major}</b>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <span>تعداد سال فعالیت:</span>
                                                            <b>{CurrencyFormat(data.yearsActive)}</b>
                                                            <span>تعداد ساعات الزامی در هفته:</span>
                                                            <b>{CurrencyFormat(data.mustHoursPerWeek)}</b>
                                                            <span>حساب بانکی:</span>
                                                            <b>{StringDigitsConvertToPersian(data.bankAccountNumber)}</b>
                                                            <span>پایه حقوق:</span>
                                                            <b>{CurrencyFormat(data.salary)}<TomansIcon/></b>
                                                            <span>کد ملی:</span>
                                                            <b>{StringDigitsConvertToPersian(data.nationalCode)}</b>
                                                            <span>نام پدر:</span>
                                                            <b>{data.fatherName}</b>
                                                            <span>محل تولد:</span>
                                                            <b>{data.birthCity}</b>
                                                            <span>نشانی:</span>
                                                            <b>{data.address}</b>
                                                            <span>شروع قرارداد:</span>
                                                            <b>{StringDigitsConvertToPersian(GregorianToPersian(data.contractStartTime).replaceAll('-', '/'))}</b>
                                                            <span>پایان قرارداد:</span>
                                                            <b>{StringDigitsConvertToPersian(GregorianToPersian(data.contractExpiresAt).replaceAll('-', '/'))}</b>
                                                            <span>حداکثر ساعات کاری روزانه:</span>
                                                            <b>{StringDigitsConvertToPersian(data.maxWorkingHoursPerDay)}</b>
                                                            <span>تعداد فرزند:</span>
                                                            <b>{CurrencyFormat(data.childCount)}</b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="screen-card">
                                                <div className="screen-card-header">
                                                    <b>کارت های کارمند</b>
                                                    <button onClick={() => setrfidModal(true)}>
                                                        <ThinAddIcon/>
                                                        <span>ثبت کارت</span>
                                                    </button>
                                                </div>
                                                {
                                                    data.cardCode === '' ?
                                                        <div className="staff--not-found">
                                                            <b>کارتی ثبت نشده</b>
                                                            <p>برای این کارمند تاکنون کارتی ثبت نشده است.</p>
                                                        </div> :
                                                        <div className="finger-item">
                                                            <div>
                                                                <em><ThinCardIcon/></em>
                                                                <div>
                                                                    <b>{data.cardCode}</b>
                                                                    <span>کارت هوشمند غیرتماسی.</span>
                                                                </div>
                                                            </div>
                                                            <button className="open-tooltip"
                                                                    onClick={() => setRemoveCard(true)}>
                                                                <ThinTrashIcon/>
                                                                <i>عدم اختصاص</i>
                                                            </button>
                                                        </div>
                                                }
                                            </div>
                                        </> :
                                        (tab === 'insurance' ?
                                            <div className="screen-card">
                                                <div className="screen-card-header">
                                                    <b>بیمه کارمند</b>
                                                    <button onClick={() => setInsuranceModal(true)}>
                                                        <ThinEditIcon/>
                                                        <span>ویرایش</span>
                                                    </button>
                                                </div>
                                                <div className="student-info">
                                                    <span>وضعیت بیمه:</span>
                                                    <b>{data.hasInsurance ? 'دارای بیمه' : 'بدون بیمه'}</b>
                                                    <span>مبلغ بیمه:</span>
                                                    <b>{CurrencyFormat(data.insuranceCost)}<TomansIcon/></b>
                                                    <span>تعداد روزهای بیمه در ماه:</span>
                                                    <b>{CurrencyFormat(data.insuranceDaysPerMonth)} روز</b>
                                                </div>
                                            </div> :
                                            (tab === 'salaries' ?
                                                <div className="screen-card">
                                                    <div className="screen-card-header">
                                                        <b>منابع حقوقی</b>
                                                        <button onClick={() => setAddEditSource({
                                                            edit: false,
                                                            id: 0,
                                                            price: 0,
                                                            show: true,
                                                            title: '',
                                                        })}>
                                                            <ThinAddIcon/>
                                                            <span>افزودن</span>
                                                        </button>
                                                    </div>
                                                    <div className="staff-salary-total">
                                                        <b>جمع کل حقوق دریافتی:</b>
                                                        <span>{CurrencyFormat(data.totalFromSources)}<TomansIcon/></span>
                                                    </div>
                                                    <table
                                                        className="table open-table table-hover table-striped table-bordered">
                                                        <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>عنوان</th>
                                                            <th>مبلغ</th>
                                                            <th>امکانات</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            data.sources.map((s, i) =>
                                                                <tr key={"Sl28Sj8Dh7_sh7D" + i}>
                                                                    <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                    <td>{StringDigitsConvertToPersian(s.title)}</td>
                                                                    <td>
                                                                        <span>{CurrencyFormat(s.price)}<TomansIcon/></span>
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-inline-flex" style={{gap: 5}}>
                                                                            <button className="open-tooltip"
                                                                                    onClick={() => setAddEditSource({
                                                                                        edit: true,
                                                                                        title: s.title,
                                                                                        show: true,
                                                                                        price: s.price,
                                                                                        id: s.id,
                                                                                    })}>
                                                                                <ThinEditIcon/>
                                                                                <i>ویرایش</i>
                                                                            </button>
                                                                            <button className="open-tooltip"
                                                                                    onClick={() => setRemoveSourceModal({
                                                                                        title: s.title,
                                                                                        show: true,
                                                                                        id: s.id,
                                                                                    })}>
                                                                                <ThinTrashIcon/>
                                                                                <i>حذف</i>
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div> :
                                                (tab === 'contract' ?
                                                        <div className="screen-card">
                                                            <div className="screen-card-header">
                                                                <b>قرارداد</b>
                                                                <div className="d-inline-flex align-items-center"
                                                                     style={{gap: 10}}>
                                                                    <button onClick={() => setContractModal(true)}>
                                                                        <ThinEditIcon/>
                                                                        <span>ویرایش</span>
                                                                    </button>
                                                                    <button
                                                                        onClick={() => window.open(`/print/admins/staff/contract/${staffId}`)}>
                                                                        <ThinPrintIcon/>
                                                                        <span>پرینت</span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="student-info">
                                                                <span>تعداد ساعات الزامی در هفته:</span>
                                                                <b>{CurrencyFormat(data.mustHoursPerWeek)}</b>
                                                                <span>حساب بانکی:</span>
                                                                <b>{StringDigitsConvertToPersian(data.bankAccountNumber)}</b>
                                                                <span>پایه حقوق:</span>
                                                                <b>{CurrencyFormat(data.salary)}<TomansIcon/></b>
                                                                <span>شروع قرارداد:</span>
                                                                <b>{StringDigitsConvertToPersian(GregorianToPersian(data.contractStartTime).replaceAll('-', '/'))}</b>
                                                                <span>پایان قرارداد:</span>
                                                                <b>{StringDigitsConvertToPersian(GregorianToPersian(data.contractExpiresAt).replaceAll('-', '/'))}</b>
                                                                <span>حداکثر ساعات کاری روزانه:</span>
                                                                <b>{StringDigitsConvertToPersian(data.maxWorkingHoursPerDay)}</b>
                                                            </div>
                                                        </div> :
                                                        (
                                                            tab === 'attend' ?
                                                                <div className="screen-card">
                                                                    <div className="screen-card-header">
                                                                        <b>اطلاعات حضورغیاب</b>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: 10
                                                                        }}>
                                                                            <div className="filter-buttons">
                                                                                <ClickOutsideDetector
                                                                                    onClickOutside={() => {
                                                                                        setFilters(v => {
                                                                                            let x = {...v};
                                                                                            x.shown = '';
                                                                                            return x;
                                                                                        });
                                                                                    }}
                                                                                    className={"filter-button-c" + (filters.shown === 'time' ? ' active' : '')}>
                                                                                    <button onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setFilters(v => {
                                                                                            let x = {...v};
                                                                                            x.shown = x.shown === 'time' ? '' : 'time';
                                                                                            return x;
                                                                                        });
                                                                                    }}>
                                                                                        <ThinTimeIcon/>
                                                                                        <span>محدودیت زمانی</span>
                                                                                        <ThinCaretDownIcon/>
                                                                                    </button>
                                                                                    {
                                                                                        filters.shown === 'time' ?
                                                                                            <div>
                                                                                                <label
                                                                                                    className="f-roboto">لطفا
                                                                                                    یک بازه زمانی را
                                                                                                    انتخاب
                                                                                                    کنید:</label>
                                                                                                <Calendar
                                                                                                    value={time}
                                                                                                    onChange={e => setTime(e)}
                                                                                                    shouldHighlightWeekends
                                                                                                    colorPrimary='#0a53be'
                                                                                                    locale={'fa'}
                                                                                                />
                                                                                                <div
                                                                                                    className="text-end">
                                                                                                    <button
                                                                                                        className="filter-button-cta"
                                                                                                        onClick={fetchAttend}>
                                                                                                        <span>اعمال تغییرات</span>
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div> :
                                                                                            null
                                                                                    }
                                                                                </ClickOutsideDetector>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        entranceList.length === 0 ?
                                                                            <div className="staff--not-found">
                                                                                <b>گزارشی یافت نشد</b>
                                                                                <p>در بازه زمانی انتخاب شده، گزارشی یافت
                                                                                    نشد.</p>
                                                                            </div> :
                                                                            null
                                                                    }
                                                                    {
                                                                        entranceList.length > 0 ?
                                                                            <table
                                                                                className="table open-table table-bordered table-hover">
                                                                                <thead>
                                                                                <tr>
                                                                                    <th>#</th>
                                                                                    <th>نوع</th>
                                                                                    <th>تاریخ</th>
                                                                                    <th>زمان</th>
                                                                                    <th>ثبت‌کننده</th>
                                                                                </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                {
                                                                                    entranceList.map((r, i) =>
                                                                                        <tr key={"Jd93222uf8" + i}>
                                                                                            <td>{StringDigitsConvertToPersian((i + 1).toString())}</td>
                                                                                            <td>{!r.isExit ? 'ورود' : 'خروج'}</td>
                                                                                            <td>{StringDigitsConvertToPersian(GregorianToPersian(r.createdAt).replaceAll('-', '/'))}</td>
                                                                                            <td>{StringDigitsConvertToPersian(r.createdAt.split(' ')[1])}</td>
                                                                                            <td>{staffAttendCreatedByToString(r.createdBy)}</td>
                                                                                        </tr>
                                                                                    )
                                                                                }
                                                                                </tbody>
                                                                            </table> : null
                                                                    }
                                                                </div> :
                                                                <div className="screen-card">
                                                                    <div className="screen-card-header">
                                                                        <b>واریزی های حقوق</b>
                                                                    </div>
                                                                    <table
                                                                        className="table open-table table-hover table-striped table-bordered">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th>عنوان</th>
                                                                            <th>مبلغ</th>
                                                                            <th>تاریخ</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {
                                                                            salariesPaid.map((s, i) =>
                                                                                <tr key={"Sl28Sj8222Dh7sss_sh7D" + i}>
                                                                                    <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                                                    <td>{StringDigitsConvertToPersian(s.title)}</td>
                                                                                    <td>
                                                                                        <span>{CurrencyFormat(s.price)}<TomansIcon/></span>
                                                                                    </td>
                                                                                    <td>
                                                                                        {StringDigitsConvertToPersian(s.createdAt.split(' ')[1] + " " + GregorianToPersian(s.createdAt.split(' ')[0]).replaceAll('-', '/'))}
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                        )
                                                )))
                                }
                            </div>
                        </div>
                    </div> : null
            }
            <input
                style={{display: 'none'}}
                type="file"
                ref={imgRef}
                onChange={onPhotoSelected}
                accept={".png,.jpg,.jpeg"}
            />
            <AdminsAddEditStaffModal
                active={editModal}
                closeHandler={() => setEditModal(false)}
                edit={true}
                staffId={staffId as string}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                    setTab('info');
                }}
            />
            <AdminsStaffInsuranceEditModal
                active={insuranceModal}
                closeHandler={() => setInsuranceModal(false)}
                staffId={staffId as string}
                hasInsurance={data.hasInsurance}
                cost={data.insuranceCost}
                days={data.insuranceDaysPerMonth}
                onDone={() => {
                    fetchData();
                }}
            />
            <AdminsStaffAddEditSalarySourceModal
                active={addEditSource.show}
                closeHandler={() => setAddEditSource(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                edit={addEditSource.edit}
                sourceId={addEditSource.id}
                title={addEditSource.title}
                price={addEditSource.price}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                    setTab('salaries');
                }}
                staffId={staffId as string}
            />
            <RemoveModal
                active={removeSourceModal.show}
                closeHandler={() => setRemoveSourceModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف منبع حقوقی؟"}
                desc={`آیا مطمئن هستید که می‌خواهید ${removeSourceModal.title} را حذف کنید؟`}
                onRemove={() => {
                    const r = {...removeSourceModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/staff/details/sources/remove',
                        {
                            id: staffId as string,
                            source: r.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'منبع حقوقی حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchData();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
            <AdminsStaffEditContractModal
                active={contractModal}
                closeHandler={() => setContractModal(false)}
                baseSalary={data.salary}
                mustHoursPerWeek={data.mustHoursPerWeek}
                maxHoursPerDay={data.maxWorkingHoursPerDay}
                startAt={data.contractStartTime}
                expiresAt={data.contractExpiresAt}
                bankAccount={data.bankAccountNumber}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
                staffId={staffId as string}
            />
            <AdminsStaffSetJobModal
                active={selectJobModal}
                closeHandler={() => setSelectJobModal(false)}
                staffId={staffId as string}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
            />
            <AdminsStaffAssignCardModal
                active={rfidModal}
                closeHandler={() => setrfidModal(false)}
                staffId={staffId as string}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                }}
            />
            <RemoveModal
                active={removeCard}
                closeHandler={() => setRemoveCard(false)}
                title={"حذف کارت"}
                desc={`آیا مطمئن هستید که می‌خواهید این کارت را حذف کنید؟`}
                onRemove={() => {
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/staff/attend/assign-card',
                        {
                            staff: staffId as string,
                            rfid: "",
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'کارت حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchData();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};